<template>
  <div class="flex h-screen flex-col items-center justify-around px-6 py-3">
    <img :src="logo" alt="" class="h-10 w-full object-contain dark:hidden">
    <img :src="darkLogo" alt="" class="hidden h-10 w-full object-contain dark:block">

    <p class="m-0 text-center text-sm leading-relaxed text-foreground">
      <template v-if="$root.language === 'hu'">
        Az {{ appName }} használatához kérjük,<br />

        nyisd be az
        <span class="font-semibold text-primary underline" @click="() => copyLinkToClipboard()">{{ domain }}</span>
        címet<br />

        <strong>közvetlenül egy böngészőből</strong>.
      </template>
      <template v-else>
        To use {{ appName }},<br />

        please open the
        <span class="font-semibold text-primary underline" @click="() => copyLinkToClipboard()">{{ domain }}</span>
        address<br />

        <strong>directly in a browser</strong>.
      </template>
    </p>

    <ui-button v-if="!isIos" @click="() => $emit('open')">
      {{ tr('Open in browser') }}
    </ui-button>
    <ui-button v-else @click="() => copyLinkToClipboard()">
      {{ tr('Copy link to clipboard') }}
    </ui-button>
  </div>
</template>

<script>
import adLogoInlineDark from '@/assets/img/ad-logo-inline--darkmode.svg';
import adLogoInline from '@/assets/img/ad-logo-inline.svg';
import mtuLogo from '@/assets/img/mtu-logo.svg';

const IS_TURISZTIKAI = process.env.VUE_APP_FORK === 'turisztikai';

export default {
  name: 'OpenInBrowser',
  props: {
    isIos: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
  data: () => ({
    logo: IS_TURISZTIKAI ? mtuLogo : adLogoInline,
    darkLogo: IS_TURISZTIKAI ? mtuLogo : adLogoInlineDark,
  }),
  computed: {
    appName() {
      return process.env.VUE_APP_HTML_TITLE;
    },
    domain() {
      return window.location.hostname;
    },
  },
  methods: {
    copyLinkToClipboard() {
      navigator.clipboard.writeText(window.location.href);
      this.infoToast(this.tr('Link successfully copied to clipboard.'));
    },
  },
};
</script>
